module.exports = __webpack_public_path__ + "static/1995-championship-018b41af8b8ac98fe2ec9f0c60baad78.jpg";